import React, { useState, useEffect, useContext } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import { Formik, Form, Field } from 'formik';
import { TextField, Select } from 'formik-material-ui';
import { DatePicker, DateTimePicker } from 'formik-material-ui-pickers';
import IconButton from '@material-ui/core/IconButton';
import Alert from '@material-ui/lab/Alert';

import { Close as CloseIcon } from '@material-ui/icons';

import {
    Box, Button, Dialog, DialogActions,
    DialogContent, DialogTitle,
    FormHelperText, Grid,
    MenuItem, Slide
} from '@material-ui/core';

import DateFnsUtils from '@date-io/date-fns';
import { format } from 'date-fns';

import {
    MuiPickersUtilsProvider,
    // KeyboardTimePicker,
    // KeyboardDatePicker,
} from '@material-ui/pickers';

import AttachFileIcon from '@material-ui/icons/AttachFile';
import { StateContext, DispatchContext } from '../../../../context/Provider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ClassworkModal = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { globalState } = appState;
    const { globalDispatch, facultyDispatch } = appDispatch;

    const [classwork, setClasswork] = useState({
        topic_id: '',
        work_type_id: '',
        title: '',
        description: '',
        // due_date: dateToISOLikeButLocal(new Date()) || "",
        due_date: "",
        // due_date: new Date().toISOString().substr(0,16),
        // due_date: "2021-05-24T10:30",
        total_pts: 0,
        is_graded: 1,
        is_published: 1
    });

    const [topicsDropdown, setTopicsDropdown] = useState([]);
    const [workTypesDropdown, setWorkTypesDropdown] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());

    const [file, setFile] = useState('');
    const [fileUploadLabel, setFileUploadLabel] = useState(
        <><AttachFileIcon /> <p style={{ marginLeft: '5px', fontWeight: '500' }}>Choose a file/attachment to upload (optional)</p></>
    );

    // 10122021
    const [files, setFiles] = useState([]);
    const [fileError, setFileError] = useState(null);

    async function createClasswork(values, resetForm) {

        const formData = new FormData();
        formData.append('classcode', props.classcode);
        formData.append('work_type_id', values.work_type_id);
        formData.append('topic_id', values.topic_id);
        formData.append('title', values.title);
        formData.append('description', values.description);
        formData.append('attachments', file);
        formData.append('total_pts', values.total_pts);
        formData.append('is_graded', values.is_graded);

        for (let i = 0; i < files.length; i++) {
            formData.append(`file[${i}]`, files[i]);
        }

        if (values.due_date) {
            // const dueDate = format(values.due_date, 'yyyy-MM-dd kk:mm:ss');
            const dueDate = format(new Date(Date.parse(values.due_date)), 'yyyy-MM-dd kk:mm:ss');
            formData.append('due_date', dueDate);
        }

        const res = await axiosConfig.post(`/classworks`, formData);

        // const res = await axiosConfig.post(`/classworks`, {
        //     classcode: props.classcode,
        //     work_type_id: values.work_type_id,
        //     topic_id: values.topic_id,
        //     title: values.title,
        //     description: values.description
        // });

        if (res.data.status_code === 'ok') {
            globalDispatch({ type: 'setSnackbarMsg', value: 'Classwork created successfully.' });
            globalDispatch({ type: 'setIsOpenSnackbar', value: true });

            props.fetchTopics();
            props.handleClose();

        } else {
            if (res.data.status_code == "FILE_TOO_LARGE") {
                setFileError((message) => res.data.errors)
            }
            console.log(res);
        }

        globalDispatch({ type: 'setIsLoading', value: false });
        setTimeout(() => {
            globalDispatch({ type: 'setIsOpenSnackbar', value: false });
        }, 1200);
    }

    async function updateClasswork(values, resetForm) {

        const formData = new FormData();
        formData.append('_method', 'PATCH');
        formData.append('work_type_id', values.work_type_id);
        formData.append('topic_id', values.topic_id);
        formData.append('title', values.title);
        formData.append('description', values.description);
        formData.append('attachments', file);
        formData.append('total_pts', values.total_pts);
        formData.append('is_graded', values.is_graded);
        formData.append('is_published', values.is_published);

        for (let i = 0; i < files.length; i++) {
            formData.append(`file[${i}]`, files[i]);
        }

        if (values.due_date) {
            try {
                const dueDate = format(values.due_date, 'yyyy-MM-dd kk:mm:ss');
                formData.append('due_date', dueDate);
            } catch (e) {
                formData.append('due_date', values.due_date);
            }
        }

        const res = await axiosConfig.post(`/classworks/${props.classworkID}`, formData);

        if (res.data.status_code === 'ok') {
            // console.log(res.data);
            globalDispatch({ type: 'setSnackbarMsg', value: 'Classwork updated successfully.' });
            globalDispatch({ type: 'setIsOpenSnackbar', value: true });

            props.handleClose();
        } else {
            if (res.data.status_code == "FILE_TOO_LARGE") {
                setFileError((message) => res.data.errors)
            }
            console.log(res);
        }

        globalDispatch({ type: 'setIsLoading', value: false });
        setTimeout(() => {
            globalDispatch({ type: 'setIsOpenSnackbar', value: false });
        }, 1200);
    }

    const fetchTopicList = () => {
        axiosConfig.get(`/topics?classcode=${props.classcode}`)
            .then(response => {
                const { data } = response.data;
                // console.log(data);
                setTopicsDropdown(data);
            })
            .catch(err => {
                console.log(err);
            });
    }

    const fetchWorkTypeList = () => {

        axiosConfig.get('/workTypes')
            .then(response => {
                const { data } = response.data;
                setWorkTypesDropdown(data);
            })
            .catch(err => {
                console.log(err);
            });
    }

    // const handleFileChange = (event) => {
    //     try {
    //         console.log(event.target.files[0].name);
    //         setFileUploadLabel(event.target.files[0].name);
    //         setFile(event.target.files[0]);
    //     } catch (e) {
    //         return;
    //     }
    // }

    // 10/12/2021
    const handleFileChange = (event) => {
        try {

            console.log(event.target.files[0]);
            let filesArr = [];

            for (let i = 0; i < event.target.files.length; i++) {
                filesArr.push(event.target.files[i]);
            }

            setFiles(filesArr);
            console.log(filesArr);

        } catch (e) {
            return;
        }
    }

    const removeFileFromArray = (selectedFile) => {
        let filesArr = [...files];
        let index = filesArr.indexOf(selectedFile);

        if (index !== -1) {
            filesArr.splice(index, 1);
            setFiles(filesArr);
        }
    }

    function dateToISOLikeButLocal(date) {
        const offsetMs = date.getTimezoneOffset() * 60 * 1000;
        const msLocal = date.getTime() - offsetMs;
        const dateLocal = new Date(msLocal);
        const iso = dateLocal.toISOString();
        const isoLocal = iso.slice(0, 16);
        return isoLocal;
    }

    useEffect(() => {

        if (props.classworkID) {
            if (props.classwork.due_date) {
                props.classwork.due_date = dateToISOLikeButLocal(new Date(props.classwork.due_date));
            } else {
                props.classwork.due_date = "";
            }

            setClasswork(props.classwork);
            console.log(props.classwork)
        }

        fetchTopicList();
        fetchWorkTypeList();

    }, [props.classworkID]);

    return (
        <>
            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
                maxWidth={'sm'}
                TransitionComponent={Transition}
                disableBackdropClick
            >
                <Formik
                    initialValues={classwork}
                    validate={(values) => {
                        const errors = {};

                        if (!values.topic_id) {
                            errors.topic_id = 'This field is required';
                        }

                        if (!values.work_type_id) {
                            errors.work_type_id = 'This field is required';
                        }

                        if (!values.title) {
                            errors.title = 'This field is required';
                        }

                        if (!values.description) {
                            errors.description = 'This field is required';
                        }

                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {


                        globalDispatch({ type: 'setIsLoading', value: true });

                        // setTimeout(() => {
                        //     setSubmitting(false);
                        //     alert(JSON.stringify(values, null, 2));
                        //     resetForm();
                        //     globalDispatch({type: 'setIsLoading', value: false});
                        // }, 500);

                        if (props.classworkID === null) {
                            await createClasswork(values, resetForm);
                        } else {
                            await updateClasswork(values, resetForm);
                        }

                        setSubmitting(false);
                    }}
                >
                    {({ submitForm, isSubmitting, touched, errors }) => (
                        <Form encType="multipart/form-data">
                            <DialogTitle id="form-dialog-title">
                                {props.dialogTitle}
                            </DialogTitle>
                            <DialogContent>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container alignItems="flex-start" spacing={2}>
                                        <Grid item xs={12}>
                                            <Field
                                                error={errors.topic_id && true}
                                                component={Select}
                                                name="topic_id"
                                                multiple={false}
                                                inputProps={{ name: 'topic_id', id: 'topic_id' }}
                                                fullWidth
                                                variant="outlined"
                                                displayEmpty
                                            >
                                                <MenuItem value={``}>-Select Topic-</MenuItem>

                                                {topicsDropdown.map((topic, i) => (
                                                    <MenuItem key={topic.id} value={topic.id}>{topic.title}</MenuItem>
                                                ))}
                                            </Field>

                                            {errors.topic_id && (
                                                <Box px={1.5}>
                                                    <FormHelperText error={true}>
                                                        {errors.topic_id}
                                                    </FormHelperText>
                                                </Box>
                                            )}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                error={errors.work_type_id && true}
                                                component={Select}
                                                name="work_type_id"
                                                multiple={false}
                                                inputProps={{ name: 'work_type_id', id: 'work_type_id' }}
                                                fullWidth
                                                variant="outlined"
                                                displayEmpty
                                            >
                                                <MenuItem value={``}>-Select Work Type-</MenuItem>

                                                {workTypesDropdown.map((workType, i) => (
                                                    <MenuItem key={workType.id} value={workType.id}>{workType.name}</MenuItem>
                                                ))}
                                            </Field>

                                            {errors.work_type_id && (
                                                <Box px={1.5}>
                                                    <FormHelperText error={true}>
                                                        {errors.work_type_id}
                                                    </FormHelperText>
                                                </Box>
                                            )}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                label="Classwork Title (required)"
                                                name="title"
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                label="Classwork Description (required)"
                                                name="description"
                                                fullWidth
                                                variant="outlined"
                                                multiline
                                                rows={4}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            {/* <Field
                                                component={DatePicker}
                                                fullWidth
                                                inputVariant="outlined"
                                                format="MM/dd/yyyy"
                                                name="due_date"
                                                label="Due Date (optional)"
                                            /> */}

                                            <Field
                                                component={TextField}
                                                name="due_date"
                                                fullWidth
                                                variant="outlined"
                                                id="datetime-local"
                                                label="Due Date (optional)"
                                                type="datetime-local"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />

                                        </Grid>

                                        <Grid item xs={12}>
                                            <Box py={1}>
                                                <Button
                                                    // className={props.classes.truncate}
                                                    variant="outlined"
                                                    size="medium"
                                                    component="label"
                                                    fullWidth
                                                    type="button"
                                                    style={{ justifyContent: "flex-start" }}
                                                >
                                                    {/* {fileUploadLabel} */}
                                                    <AttachFileIcon /> <p style={{ marginLeft: '5px', fontWeight: '500' }}>Choose file/s to upload (optional)</p>
                                                    <input type="file" multiple onChange={handleFileChange} hidden />
                                                </Button>
                                            </Box>

                                            {fileError && <Alert severity="error" style={{ marginBottom: '10px' }}>
                                                {fileError}
                                            </Alert>}

                                            {
                                                props.classworkID ? (
                                                    <Alert severity="warning">Note: Uploading new file/s will replace the previous attachments</Alert>
                                                ) : null
                                            }

                                            {files.map((file, i) => (
                                                <Box py={0} key={i + 1}>
                                                    <Button
                                                        style={{ justifyContent: "flex-start", height: "35px", paddingLeft: 0, backgroundColor: "transparent" }}
                                                        size="small"
                                                        component="label"
                                                        fullWidth
                                                        type="button"
                                                        disableRipple
                                                    >
                                                        <Box>
                                                            <IconButton
                                                                style={{ backgroundColor: "transparent" }}
                                                                aria-label="delete"
                                                                disableRipple
                                                                onClick={() => removeFileFromArray(file)}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </Box>
                                                        {file.name || ""}
                                                    </Button>
                                                </Box>
                                            ))}
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Field
                                                error={errors.is_graded && true}
                                                component={Select}
                                                name="is_graded"
                                                multiple={false}
                                                inputProps={{ name: 'is_graded', id: 'is_graded' }}
                                                fullWidth
                                                variant="outlined"
                                                displayEmpty
                                            >
                                                <MenuItem value={1}>Classwork - Is Graded</MenuItem>
                                                <MenuItem value={0}>Classwork - Non Graded</MenuItem>
                                            </Field>

                                            {errors.is_graded && (
                                                <Box px={1.5}>
                                                    <FormHelperText error={true}>
                                                        {errors.is_graded}
                                                    </FormHelperText>
                                                </Box>
                                            )}
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                label="Total Points"
                                                name="total_pts"
                                                type="number"
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Field
                                                error={errors.is_published && true}
                                                component={Select}
                                                name="is_published"
                                                multiple={false}
                                                inputProps={{ name: 'is_published', id: 'is_published' }}
                                                fullWidth
                                                variant="outlined"
                                                displayEmpty
                                            >
                                                <MenuItem value={1}>Published</MenuItem>
                                                <MenuItem value={0}>Save as Draft</MenuItem>
                                            </Field>

                                            {errors.is_published && (
                                                <Box px={1.5}>
                                                    <FormHelperText error={true}>
                                                        {errors.is_published}
                                                    </FormHelperText>
                                                </Box>
                                            )}
                                        </Grid>

                                    </Grid>
                                </MuiPickersUtilsProvider>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={props.handleClose}
                                    disabled={isSubmitting}
                                    color="secondary"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    disabled={isSubmitting}
                                    onClick={submitForm} color="primary"
                                >
                                    Submit
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
}

export default ClassworkModal;